// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__4Cu7D","boxTitle":"Qualiphy_boxTitle__3-F-f","box":"Qualiphy_box__2GcBH","toggleWrap":"Qualiphy_toggleWrap__2QU27"};